import { render, staticRenderFns } from "./StockProductEdit.vue?vue&type=template&id=32c0f13f"
import script from "./StockProductEdit.vue?vue&type=script&lang=js"
export * from "./StockProductEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports